import { INCIDENTS_SET, INCIDENT_ADDED, INCIDENT_EDITED, INCIDENT_DELETED } from 'src/app/redux/redux-types';
import { reduxIncidentTypes } from 'src/types';

export const incidentDefaultState: reduxIncidentTypes.StateType = {
  incidentList: [],
};

export const incidentReducer = (
  state = incidentDefaultState,
  action: reduxIncidentTypes.ActionType,
): reduxIncidentTypes.StateType => {
  switch (action.type) {
    case INCIDENTS_SET:
      return {
        ...state,
        incidentList: action.payload,
      };
    case INCIDENT_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.incidentList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        incidentList: [action.payload, ...state.incidentList],
      };
    case INCIDENT_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.incidentList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        incidentList: [
          ...state.incidentList.slice(0, updateIndex),
          action.payload,
          ...state.incidentList.slice(updateIndex + 1),
        ],
      };
    case INCIDENT_DELETED:
      return {
        ...state,
        incidentList: state.incidentList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
